import { $iq, Strophe } from "strophe.js";
import { StrophePlugin } from "./strophe-plugin";
import { RSM } from "./strophe.rsm";

export class StropheMAMPlugin extends StrophePlugin {
    private _p = ["with", "start", "end", "around", "msg_id"];

    public constructor() {
        super('mam');
    }

    public static build() { return new StropheMAMPlugin(); }

    public init(conn: any): void {
        super.init(conn);
        Strophe.addNamespace("MAM", "urn:xmpp:mam:1");
    }

    public query(jid, options) {
        const _p = this._p;
        const attr = {
            type: "set",
            id: jid
        };
        const mamAttr: any = { xmlns: Strophe.NS.MAM };
        if (options.queryid) {
            mamAttr.queryid = options.queryid;
            delete options.queryid;
        }
        const iq = $iq(attr).c("query", mamAttr).c("x", { xmlns: "jabber:x:data", type: "submit" });

        iq.c("field", { "var": "FORM_TYPE", type: "hidden" }).c("value").t("urn:xmpp:mam:1").up().up();
        let i;
        for (i = 0; i < this._p.length; i++) {
            const pn = _p[i];
            const p = options[pn];
            delete options[pn];
            if (p) {
                iq.c("field", { "var": pn }).c("value").t(p).up().up();
            }
        }
        iq.up();

        delete options.onMessage;
        const onComplete = options.onComplete;
        const onError = options.onError;
        delete options.onComplete;
        delete options.onError;
        iq.cnode(new RSM(options).toXML());

        //this._c.addHandler(onMessage, Strophe.NS.MAM, "message", null);
        return this.connection.sendIQ(iq, onComplete, onError);
    }

    public querymuc(jid, to, options) {
        const _p = this._p;
        const attr = {
            to: to,
            type: "set",
            id: jid
        };
        const mamAttr: any = { xmlns: Strophe.NS.MAM };
        if (options.queryid) {
            mamAttr.queryid = options.queryid;
            delete options.queryid;
        }
        const iq = $iq(attr).c("query", mamAttr).c("x", { xmlns: "jabber:x:data", type: "submit" });

        iq.c("field", { "var": "FORM_TYPE", type: "hidden" }).c("value").t(Strophe.NS.MAM).up().up();
        let i;
        for (i = 0; i < this._p.length; i++) {
            const pn = _p[i];
            const p = options[pn];
            delete options[pn];
            if (p) {
                iq.c("field", { "var": pn }).c("value").t(p).up().up();
            }
        }
        iq.up();

        const onComplete = options.onComplete;
        const onError = options.onError;
        delete options.onComplete;
        delete options.onError;
        iq.cnode(new RSM(options).toXML());

        return this.connection.sendIQ(iq, onComplete, onError);
    }

    public delete(queryId, options) {
        const _p = this._p;
        const attr = {
            type: "set",
            id: queryId
        };
        const mamAttr: any = { xmlns: Strophe.NS.MAM };
        if (options.queryid) {
            mamAttr.queryid = options.queryid;
            delete options.queryid;
        }

        const iq = $iq(attr).c("delete", mamAttr).c("x", { xmlns: "jabber:x:data", type: "submit" });

        iq.c("field", { "var": "FORM_TYPE", type: "hidden" }).c("value").t(Strophe.NS.MAM).up().up();
        let i;
        for (i = 0; i < this._p.length; i++) {
            const attribKey = _p[i];
            const attribValue = options[attribKey];
            if (attribValue) {
                iq.c("field", { "var": attribKey }).c("value").t(attribValue).up().up();
            }
        }
        iq.up();

        delete options.onMessage;
        const onComplete = options.onComplete;
        delete options.onComplete;
        iq.cnode(new RSM(options).toXML());

        //this._c.addHandler(onMessage, Strophe.NS.MAM, "message", null);
        return this.connection.sendIQ(iq, onComplete);
    }
}
